import {useEffect, useRef} from "react";

// Calls `callback` every `interval` ms while `active` is true
export const usePolling = (callback, active, interval) => {
  const saved = useRef(callback);
  saved.current = callback;

  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => saved.current(), interval);
    return () => clearInterval(id);
  }, [active, interval]);
};
